/**
 * Created by mqamhieh on 11/22/16.
 */
(function (app) {

    'use strict';

    var CAMERA_TAG_SRC = '//cameratag.com/api/v13/js/cameratag.min.js?v=' + Date.now();

    var setCameraTagText = function () {
        CT_i18n[0] = $filter("translate")("To record this video using your mobile phone please visit <<url>> in your mobile browser");
        CT_i18n[1] = $filter("translate")("Your mobile device does not support video uploading");
        CT_i18n[2] = $filter("translate")("Please make sure you have Flash Player 11 or higher installed");
        CT_i18n[3] = $filter("translate")("Unable to embed video recorder. Please make sure you have Flash Player 11 or higher installed");
        CT_i18n[4] = $filter("translate")("choose a method below to submit your video");
        CT_i18n[5] = $filter("translate")("record from webcam");
        CT_i18n[6] = $filter("translate")("upload a file");
        CT_i18n[7] = $filter("translate")("record from phone");
        CT_i18n[8] = $filter("translate")("wave to the camera");
        CT_i18n[9] = $filter("translate")("recording in");
        CT_i18n[10] = $filter("translate")("uploading...");
        CT_i18n[11] = $filter("translate")("click to stop recording");
        CT_i18n[12] = $filter("translate")("click to skip review");
        CT_i18n[13] = $filter("translate")("Send");
        CT_i18n[14] = $filter("translate")("Record over");
        CT_i18n[15] = $filter("translate")("Review");
        CT_i18n[16] = $filter("translate")("please wait while we push pixels");
        CT_i18n[17] = $filter("translate")("published");
        CT_i18n[18] = $filter("translate")("Enter your <b>mobile phone number</b> below and we will text you a link for mobile recording");
        CT_i18n[19] = $filter("translate")("Send Mobile Link");
        CT_i18n[20] = $filter("translate")("cancel");
        CT_i18n[21] = $filter("translate")("Check your phone for mobile recording instructions");
        CT_i18n[22] = $filter("translate")("or point your mobile browser to");
        CT_i18n[23] = $filter("translate")("drop file to upload");
        CT_i18n[24] = $filter("translate")("sending your message");
        CT_i18n[25] = $filter("translate")("please enter your phone number!");
        CT_i18n[26] = $filter("translate")("that does not appear to be a valid phone number");
        CT_i18n[27] = $filter("translate")("Unable to send SMS.");
        CT_i18n[28] = $filter("translate")("No Camera Detected");
        CT_i18n[29] = $filter("translate")("No Microphone Detected");
        CT_i18n[30] = $filter("translate")("Camera Access Denied");
        CT_i18n[31] = $filter("translate")("Lost connection to server");
        CT_i18n[32] = $filter("translate")("Playback failed");
        CT_i18n[33] = $filter("translate")("Unable To Connect");
        CT_i18n[34] = $filter("translate")("Unable to publish your recording.");
        CT_i18n[35] = $filter("translate")("Unable to submit form data.");
        CT_i18n[36] = $filter("translate")("uploading your video");
        CT_i18n[37] = $filter("translate")("buffering video playback");
        CT_i18n[38] = $filter("translate")("publishing");
        CT_i18n[39] = $filter("translate")("connecting...");
        CT_i18n[40] = $filter("translate")("negotiating firewall...");
    };

    var videoCamera;

    var VideoCamera = function () {

        var self = this;
        var initialized;

        self.init = function () {
            var defer = $q.defer();

            if (initialized && typeof(CameraTag) !== 'undefined') {
                defer.resolve();
            }
            else {
                getScriptCcd(CAMERA_TAG_SRC, function () {
                    initialized = true;
                    setCameraTagText();
                    defer.resolve();
                });
            }

            return defer.promise;
        }

    };

    VideoCamera.getInstance = function () {
        if (!videoCamera) {
            videoCamera = new VideoCamera();
        }

        return videoCamera;
    };

    app.directive('videoAnswer', ['$compile', 'DispatcherServices', '$timeout', 'deviceChecker', function ($compile, DispatcherServices, $timeout, deviceChecker) {
        return {
            templateUrl: '../modules/job_apply/views/video_answer_directive.html',
            restrict: 'E',
            transclude: true,
            scope: {
                ngModel: '=',
                id: '@',
                question: '=',
                formId: '@',
                applicationId: '@',
                userId: '=',
                jobIds: '=',
                bulk: '=',
                onVideoProcessed: '&',
                onVideoPublished: '&'
            },
            link: function ($scope, $element, $attrs) {

                var videoId = $scope.id;
                var videoCamId = 'camera-' + videoId;
                var nunjucks = DispatcherServices.getNunjucks();
                var camera;
                var countTimer;

                var reset = function () {

                    try {
                        CameraTag.cameras[videoCamId].destroy();
                    }
                    catch (e) {
                        console.error("Error in destroying camera:", e);
                    }

                    clearInterval(countTimer);
                    $scope.loading = false;
                };

                $element.find("img").on("error", function (e) {
                    if ($(this).attr('src')) {
                        if ($scope.ngModel && $scope.ngModel.media_uuid) {
                            $scope.ignoreTranscoded = true;
                            $scope.$digest();
                        }
                    }
                });

                var start = function () {

                    $('#camera-modal')
                        .modal('show')
                        .on('hidden.bs.modal', function (event) {
                            if (!$scope.processing) {
                                reset();
                            }
                        });

                    $('#camera-modal .harri_cameratag_record')
                        .click(function () {
                            camera = CameraTag.cameras[videoCamId];

                            if (camera) {
                                camera.record();
                            }
                            else {
                                console.warn("No camera found, calling initialize");
                                CameraTag.setup();
                            }
                        });

                    CameraTag.observe(videoCamId, 'destroyed', function () {
                        console.log("Camera Tag", "Destroy event called");
                    });

                    CameraTag.observe(videoCamId, 'initialized', function () {
                        console.log("Camera Tag", "Initialized event called");
                        $scope.loading = false;
                        $scope.$digest();
                        camera = CameraTag.cameras[videoCamId];

                        $('#camera-modal video').on('loadedmetadata', function (event) {
                            

                            if(deviceChecker.isMobile() && this.duration !== Infinity) {
                                var videoDuration = this.duration;

                                if (videoDuration > publicConfiguration.cameraTagVideoLength) {
                                    hAlert(
                                        $filter("translate")("Video is too long"),
                                        $filter("translate")("Your video answer shouldn't exceed ") + publicConfiguration.cameraTagVideoLength + " " + $filter("translate")("seconds")
                                    );

                                    this.src = "";
                                    camera.reset();
                                }

                                if (videoDuration < 3) {
                                    hAlert(
                                        $filter("translate")("Video is too short"),
                                        $filter("translate")("Your video answer should be 3 seconds at least")
                                    );

                                    this.src = "";
                                    camera.reset();
                                }
                            }
                        });
                    });

                    CameraTag.observe(videoCamId, 'recordingStarted', function () {
                        $('#camera-modal .cameratag_record_timer_prompt').text(publicConfiguration.cameraTagVideoLength);
                        $('#camera-modal #harri-cameratag-timer').text(publicConfiguration.cameraTagVideoLength);

                        clearInterval(countTimer);
                        countTimer = setInterval(function () {
                            showRecordingTimer();
                        }, 1000);
                    });

                    CameraTag.observe(videoCamId, 'recordingStopped', function () {
                        clearInterval(countTimer);
                    });


                    CameraTag.observe(videoCamId, 'readyToPublish', function () {
                        var data = {
                            'form_id': $scope.formId,
                            'question_id': $scope.question.id
                        };
                        if ($scope.bulk) {
                            data.user_id = $scope.userId;
                            data.job_ids = $scope.jobIds;
                        } else {
                            data.application_id = $scope.applicationId;
                        }

                        camera.addVideoData(data);
                    });

                    CameraTag.observe(videoCamId, 'published', function () {
                        $scope.processing = true;
                        var cameraTagVideo = camera.getVideo();
                        $scope.ngModel = {
                            external_video: {
                                uuid: cameraTagVideo.uuid,
                                service: 'camera-tag'
                            }
                        };

                        $('#camera-modal').modal('hide');

                        $scope.$digest();

                        setTimeout(function () {
                            $scope.question.answer_with_text = false;

                            // To make sure that an error in the handler, will not block the behaviour flow
                            $scope.onVideoPublished({ video: cameraTagVideo });
                        }, 1);
                    });

                    CameraTag.observe(videoCamId, 'publishFailed', function () {
                        $scope.processing = false;
                        $scope.ngModel = {};
                        $scope.cameraTagVideo = null;
                        $scope.$digest();
                    });

                    CameraTag.observe(videoCamId, 'processed', function () {
                        $scope.processing = false;
                        $scope.cameraTagVideo = camera.getVideo();
                        $scope.onVideoProcessed({ video: $scope.cameraTagVideo });
                        reset();
                        $scope.$digest();
                    });

                    CameraTag.setup();
                };

                var showRecordingTimer = function () {
                    var countDownValue = $('#camera-modal .cameratag_record_timer_prompt').text().replace(/[\(\)]/g, '');
                    $('#camera-modal #harri-cameratag-timer').text(countDownValue);
                };

                $scope.startAnswer = function (event) {
                    $scope.loading = true;

                    nunjucks.render("../modules/job_apply/views/camera_tag_modal.html", {
                        videoCamId: videoCamId,
                        cameraTagAppId: publicConfiguration.CameraTagAppKey,
                        maxLength: publicConfiguration.cameraTagVideoLength,
                        start_screen_text: $scope.question.question,
                        useWebRTC: !!(!deviceChecker.isWindows() || deviceChecker.isChrome())
                    }, function (err, html) {
                        if (err) {
                            console.error("Error:", err);
                            return;
                        }

                        html = $compile(html)($scope);

                        $('.camera_tag_modal').remove();
                        $('body').append(html);

                        VideoCamera
                            .getInstance()
                            .init()
                            .then(function () {
                                start();
                                $scope.$digest();
                            });
                    });
                };

                $scope.removeVideo = function () {
                    $scope.ngModel = {};
                    $scope.cameraTagVideo = null;
                };

                $scope.closeModal = function () {
                    $('#camera-modal').modal('hide');
                };
            }
        };
    }]);

})(angular.module('harriApp'));
